export const DEFAULT_LOCALE = 'pl';

export default { pl: DEFAULT_LOCALE, en: 'en' };

export const API_LOCALES = ['en'];
